import { createApi } from '@reduxjs/toolkit/query/react';
import { createTimelyBaseQuery } from 'api/core/base';

const stripLeadingSlash = (url: string): string => url.replace(/^\//, '');

export const timelyCreateApiBase = createApi({
  reducerPath: 'timelyApi',
  baseQuery: createTimelyBaseQuery({
    prepareUrl: stripLeadingSlash,
  }),
  endpoints: () => ({}),
});
